import React from 'react'
import Text from '../../../../../elements/Typo/Text'

interface Props {
    label: string
    active: boolean
    onClick: () => void
    testId: string
    className?: string
}

const FilterTabButton: React.FC<Props> = ({ label, active, onClick, testId, className = 'cursor-pointer relative h-full flex items-center' }) => (
    <button type="button" className={className} onClick={onClick} data-testid={testId}>
        <Text size="xl" className={`font-medium ${active ? '' : 'text-[#babdbe]'}`}>
            {label}
        </Text>
        <div className={`absolute bottom-0 left-1/2 -translate-x-1/2 border-b-2 border-primary transition-all ${active ? 'w-1/3 opacity-100' : 'w-full opacity-0'}`}></div>
    </button>
)

export default FilterTabButton
